module.exports = __webpack_public_path__ + "static/media/icon_time_fill.2b3816a9.svg";